// extracted by mini-css-extract-plugin
module.exports =  {"tabs":"tabs__ua1aD","tab":"tab__i0OKE","tabContent":"tabContent__mBGnh"};